import globalMessaging from "analytics/global_messaging";
import quickmatch from "analytics/quickmatch";
import selfProfile from "analytics/self_profile";
import profileQuestions from "analytics/profile_questions";
import questions from "analytics/questions";
import alistPackages from "analytics/alist_packages";
import onboarding from "analytics/onboarding";
import photoUpload from "analytics/photo_upload";
import photoOrganizer from "analytics/photo_organizer";
import profileDetails from "analytics/profile_details";
import whatIWant from "analytics/what_i_want";
import incognitoPackages from "analytics/incognito_packages";
import signup from "analytics/signup";
import login from "analytics/login";
import splash from "analytics/splash";

const analyticsMiddleware = {
	globalMessaging,
	quickmatch,
	selfProfile,
	profileQuestions,
	questions,
	alistPackages,
	onboarding,
	photoUpload,
	photoOrganizer,
	profileDetails,
	whatIWant,
	incognitoPackages,
	login,
	splash,
	signup,
};

export default analyticsMiddleware;



// WEBPACK FOOTER //
// ./src/routers/Desktop/Store/analyticsMiddleware.js